const SYNC_COPY_PATTERNS = [
  /\s*\(aguardando sincroniza[cç][aã]o\)/gi,
  /(?:mercado pago|xpay)\s+indica\s+pagamento\s+aprovado\s*[—–-]\s*pode\s+estar\s+pendente\s+de\s+sincroniza[cç][aã]o\s+interna\.?/gi,
];

/** Normaliza textos de passagens para exibição ao operador (perspectiva XPay, sem jargão MP). */
export function sanitizePassagemUserCopy(text) {
  if (text == null || text === "") return "";
  let value = String(text);
  for (const pattern of SYNC_COPY_PATTERNS) {
    value = value.replace(pattern, "");
  }
  value = value
    .replace(/registrad[oa]s?\s+no\s+mercado\s+pago/gi, "registradas via XPay")
    .replace(/registrad[oa]s?\s+no\s+mp\b/gi, "registradas via XPay")
    .replace(/\bno\s+mercado\s+pago\b/gi, "via XPay")
    .replace(/\btentativa\(s\)\s+no\s+mercado\s+pago\b/gi, "tentativa(s) via XPay")
    .replace(/\btentativa\(s\)\s+no\s+mp\b/gi, "tentativa(s) via XPay")
    .replace(/\bdetalhe\s+mp\s*:/gi, "Detalhe:")
    .replace(/\bmotivo\s+mp\s*:/gi, "Motivo:")
    .replace(/\bsitua[cç][aã]o\s+no\s+mp\s*:/gi, "Situação no XPay:")
    .replace(/\bmercado\s+pago\b/gi, "XPay");
  return value.replace(/\s{2,}/g, " ").trim();
}
